import Markdown from "markdown-to-jsx";
import React from "react";
import { UserInfoFormikValues } from "../types";

interface TermsOfServiceProps {
  name: string;
  privacyUrl: string;
  tosUrl: string;
  termsOfService: string;
}

const MarkdownAnchor: React.FC = (props) => {
  return <a target="_blank" {...props} />;
};

export function TermsOfService(props: TermsOfServiceProps) {
  if (props.termsOfService !== "") {
    return (
      <Markdown
        options={{
          overrides: {
            a: {
              component: MarkdownAnchor,
              props: {
                className: "underline",
              },
            },
          },
        }}
      >
        {props.termsOfService}
      </Markdown>
    );
  }

  return (
    <span>
      I agree to receive automated text messages at the phone number provided.
      For more information, see {props.name}'s{" "}
      <a className="underline" href={props.tosUrl} target="_blank">
        Terms of Service
      </a>{" "}
      and{" "}
      <a className="underline" href={props.privacyUrl} target="_blank">
        Privacy Policy
      </a>
      .
    </span>
  );
}
